import React from 'react'
import { Fade } from "react-awesome-reveal";


const TechStack = () => {
  const skills = [
    "REACT",
    "NEXT.JS",
    "JAVASCRIPT",
    "ASTRO.JS",
    "TAILWIND CSS",
    "GIT",
    "FIREBASE",
    "REDUX",
    // "APPWRITE"
  ];

  const skillClass =
    "border-b-[0.0625rem] border-[#e5e5e5] hover:bg-[rgba(77,234,167,0.9)] hover:text-gray-700 tech-stack py-4 px-1 hover:border-none";
    
  return (
    <div className="skills-section mt-[5rem] lg:mt-[7rem]">
      <Fade direction="up" triggerOnce={true} fraction={1}>
        <div className="tech-stack mb-[4rem] text-[2.75rem] tracking-[-0.25rem] leading-[3.375rem] md:mb-[5rem] md:text-[3.125rem] lg:text-[4.375rem] lg:leading-[5rem] xl:mb-[6rem]">
          Tech Stack
        </div>
      </Fade>
      <div className="my-skills text-[6.2vw] md:text-[2.01rem] lg:text-[2.5rem] grid grid-cols-2 items-end leading-[100%] break-words md:flex gap-[2.1rem] flex-wrap">
        <Fade direction="up" cascade damping={0.1} triggerOnce fraction={1}>
          {skills.map((skill, index) => (
            <div key={index} className={skillClass}>
              {skill}
            </div>
          ))}
        </Fade>
      </div>
    </div>
  )
}

export default TechStack